import React, { useState, useEffect } from "react";
import LoadingUI from "../../common/LoadingUI";
import { Box, Card, Grid, IconButton, Stack, Typography } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";

import { useDispatch, useSelector } from "react-redux";
import { userPublisherDataAction } from "../../redux/toolkit/dashboard/userPublisherData";

const TotalUserCount = () => {
  const [missionAttempts, setMissionAttempts] = useState("");
  const dispatch = useDispatch();

  const dashboard = useSelector((state) => state.userPublisherData);
  const { message, data, status, loading } = dashboard;

  const handleMissionAttemptRefresh = async () => {
    dispatch(userPublisherDataAction());
  };

  // useEffect
  useEffect(() => {
    dispatch(userPublisherDataAction());
  }, [dispatch]);
  return (
    <>
      <Card
        elevation={0}
        sx={{ p: 2, borderRadius: "11px", height: "116px", position:"relative", background: "rgba(254, 206, 113, 0.16)" }}
      >
        {loading ? (
          <LoadingUI justifyContent="flex-start" />
        ) : (
          <Typography fontSize={{
            xs: "22px",
            sm: "30px",
            md: "20px",
            lg: "30px",
            xl: "30px",
          }} color="#071D45" fontWeight={700} variant="h4">
            {data[0]?.count ? data[0]?.count : "--"}
          </Typography>
        )}

        <Stack direction={"row"} position={"absolute"} bottom={10} left={10} justifyContent="space-between">
          <Typography variant="p">Total New User</Typography>
          {/* <IconButton onClick={handleMissionAttemptRefresh}><CachedIcon /></IconButton> */}
        </Stack>
      </Card>
    </>
  );
};

export default TotalUserCount;
